import gql from 'graphql-tag';

export default gql`
    fragment Arrangers on Funeral {
        Arrangers {
            ID
            Allocation
            Member {
                ID
                Surname
                FirstName
                Email
            }
        }
    }
`;
